export default __webpack_public_path__ + "static/media/mist.9b994df2.svg";